module.exports = __webpack_public_path__ + "assets/media/app-store.7afc8d9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoSuccessStep/app-store.png
// module id = 3081
// module chunks = 0